// @ts-nocheck
import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import { StaticQuery, graphql } from "gatsby";

import AnchorLink from "../anchorLink";

import styles from "./styles.css";

function BlogMenuComponent({ currentId, items }) {
    return (
        <div className={styles.BlogMenuComponent}>
            <ul className={styles.menuList}>
                {items.map((item) => (
                    <li key={item.slug} className={cn(styles.item, currentId === item.id && styles["item--isCurrent"])}>
                        <AnchorLink href={item.slug ? `/blog/${item.slug}/` : "/blog/"}>{item.title}</AnchorLink>
                    </li>
                ))}
            </ul>
        </div>
    );
}

BlogMenuComponent.propTypes = {
    currentId: PropTypes.string,
    items: PropTypes.array,
};

export default function BlogMenu({ currentId }) {
    return (
        <StaticQuery
            query={graphql`
                query {
                    contentfulArticlesList: allContentfulArticlesList(sort: { fields: createdAt, order: ASC }) {
                        nodes {
                            id
                            slug
                            title
                        }
                    }
                }
            `}
            render={(data) => {
                return <BlogMenuComponent items={data.contentfulArticlesList.nodes} currentId={currentId} />;
            }}
        />
    );
}

BlogMenu.propTypes = {
    currentId: PropTypes.string,
};
